import Vue from 'vue';
import { AccountPageLoadEvent } from '../../../services/analytics/events';

Vue.directive('track-account-page-load', {
  async inserted(el, binding, vnode) {
    const analytics = vnode.context?.$services.analytics;
    analytics?.send(new AccountPageLoadEvent(binding.arg ?? ''));
  },
});
